module.exports = __webpack_public_path__ + "img/login_image_revenue.21504f32.png";